import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";

const testimonials = [
  {
    name: "James Carter",
    company: "Tech Innovators Inc.",
    testimonial:
      "Muhammad Abu Bakar is incredibly skilled in web development. He transformed our outdated website into a modern and responsive platform, which significantly improved our user experience.",
  },
  {
    name: "Sophia Lee",
    company: "DesignX Studio",
    testimonial:
      "Abu Bakar’s web design expertise is exceptional. He created a beautiful and functional website for us that perfectly aligns with our brand vision.",
  },
  {
    name: "Mohammad Kohbandi",
    company: "Almokhtar Real Estate LLC",
    testimonial:
      "I was impressed by his professionalism and technical knowledge.Muhammad Abu Bakar handled our website management with great attention to detail and efficiency.",
  },
  {
    name: "Muhammad Yaseen",
    company: "Kamconeng",
    testimonial:
      "Abu Bakar helped us redesign our old website, and the results were fantastic. The site is now faster, more attractive, and user-friendly.",
  },
  {
    name: "Simon Gomez",
    company: "Tkambio",
    testimonial:
      "His expertise in web development is unmatched. Abu Bakar delivered a high-quality solution on time and within budget. Highly recommend his services!",
  },
];

const Testimonials = () => {
  return (
    <div className="gradul md:py-20 py-10" id="testimonials">
      <div className="max-w-7xl mx-auto px-4 flex flex-col items-center">
        <div className="text-center mb-10">
          <span className="bg-[#0788ff33] px-3 py-1 rounded-full uppercase text-sm tracking-wide">
            Testimonials
          </span>
          <h2 className="text-3xl font-bold mt-3 uppercase">
            My Client's <span className="text-blue-500">Feedback</span>
          </h2>
          <p className="text-gray-500 mt-2">
            Here's what my clients have to say about my work.
          </p>
        </div>
        <div className="w-full">
          <Swiper
            modules={[Pagination, Navigation]}
            slidesPerView={2}
            spaceBetween={30}
            pagination={{ clickable: true }}
            loop={true}
            breakpoints={{
              1024: { slidesPerView: 2 },
              360: { slidesPerView: 1 },
            }}
            className="mySwiper md:h-[250px] h-[280px]"
          >
            {testimonials.map((item, index) => (
              <SwiperSlide key={index} >
                <div className="flex flex-col md:h-[190px] gradbot border border-darklight shadow-lg shadow-secondary/70 hover:border-secondary rounded-lg p-6">
                  <q className="text-darklight italic">{item.testimonial}</q>
                  <div className="mt-4">
                    <h4 className="text-lg font-bold text-secondary">
                      {item.name}
                    </h4>
                    <p className="text-sm text-gray-500">{item.company}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
